// extracted by mini-css-extract-plugin
export var aircallIframe = "_m1-3";
export var fabContainer = "_m1-5";
export var fabRinging = "_m1-6";
export var loadingOverlay = "_m1-4";
export var pulse = "_m1-7";
export var widgetContent = "_m1-2";
export var widgetPanel = "_m1-0";
export var widgetPanelExpanded = "_m1-1";